import React from 'react';
import styled from 'styled-components';
import animations from '../styles/animations';
import { themify } from '../styles/mixins';
import { Icon } from './Icon';
import CaretDownCircle from '../icons/line/CaretDownCircle';
const StyledScrollArrow = styled(Icon).withConfig({
  displayName: "ScrollArrow__StyledScrollArrow",
  componentId: "xexqbq-0"
})(["position:absolute;bottom:30px;right:30px;animation:", ";animation-duration:1s;animation-delay:0.5s;animation-iteration-count:3;"], animations.bounce);
export const ScrollArrow = ({
  color = 'green'
}) => /*#__PURE__*/React.createElement(StyledScrollArrow, {
  icon: CaretDownCircle,
  stroke: themify(color),
  width: "32px",
  height: "32px"
});